module.exports = __webpack_public_path__ + "img/frame.f301901b.webp";